
  <div class="modal-content ">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row">
          <div class="col-md-8">
            Review Activity
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>




      </div>
      <form class="form " novalidate="" #f="ngForm">
        <div class="modal-body padding-top-0px padding-bottom-0px">
          <div class="row border-top border-bottom  bk-color-light" *ngFor="let l of CurrentCounsellingPlanController">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.DisplayName}}</label></div>
            </div>
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.Gender}},{{l.Age}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.Telephone1}}</label></div>
            </div>
          </div>
          <div class="row border-top border-bottom  bk-color-light" *ngFor="let l of CurrentCounsellingPlanController">
            <div class="col-md-4  text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14 font-weight-bold">{{l.TreatmentPlan}}</label></div>
            </div>
            <!--<div class="col-md-3  text-align-left border-right-1px">

      <div><label class="margin-bottom-0px font-size-14">{{l.StartDate|date:'MMM-dd-yyyy'}}</label></div>
    </div>-->
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14">{{l.FinancialStatus}}</label></div>
            </div>
            <div class="col-md-4 text-align-left border-right-1px">

              <div><label class="margin-bottom-0px font-size-14"><i class="fa fa-check margin-right-3px color-Assign" *ngIf="l.PlanStatus=='Active'"></i>{{l.PlanStatus}}</label></div>
            </div>
          </div>


          <div class="row border-bot-2px">
            <div class="col-md-6 border-right-2px background-lightblue">
              <div class="row border-bot-2px">
                <div class="col-md-12 text-align-left">
                  Current Activity
                </div>

              </div>
              <div class="row margin-top-10">
                <div class="col-md-7">
                  <div class="row">
                    <div class="col-md-6 padding-right-0px">
                      <label class="font-size-13px margin-bottom-0px">Schedule Date</label>
                    </div>:
                    <div class="col-md-5 padding-right-0px padding-left-0px">
                      <label class="font-size-13px margin-bottom-0px color-primary background-secondary padding-3px border-radius-3px margin-left-3px">{{ADate| date:'MMM-dd-yyyy'}}</label>
                    </div>
                  </div>

                </div>
                <div class="col-md-5 text-align-right">
                  <div class="row">
                    <div class="col-md-7 padding-left-0px padding-right-0px">
                      <label class="font-size-13px margin-bottom-0px">Schedule Time</label>
                    </div>:
                    <div class="col-md-1 padding-right-0px padding-left-0px">
                      <label class="font-size-13px margin-bottom-0px">{{Time}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row margin-left-auto margin-bottom-10px margin-top-10">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date</label>
                    </div>


                    <div class="col-md-6">
                      <div class="date-form">
                        <input class="form-control" placeholder="Actual Date"
                               name="dp" [(ngModel)]="ActualActivityDate" ngbDatepicker #d="ngbDatepicker" required #DateOfBirth="ngModel">
                        <small class="form-text text-danger"
                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Time</label>
                    </div>


                    <div class="col-md-6">
                      <input type="time" class="form-control"
                             id="CurrentEditCounsellingActivityRequest.ActualActivityTime" placeholder="Activity Time"
                             [(ngModel)]="CurrentEditCounsellingActivityRequest.ActualActivityTime"
                             name="CurrentEditCounsellingActivityRequest.ActualActivityTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Mode</label>
                    </div>


                    <div class="col-md-6">
                      <CodeTypeValue CodeType="FWUM"
                                     id="CurrentEditCounsellingActivityRequest.FollowupMode"
                                     [(ngModel)]="CurrentEditCounsellingActivityRequest.FollowupMode" SelectedValue="CurrentEditCounsellingActivityRequest.FollowupMode"
                                     name="CurrentEditCounsellingActivityRequest.FollowupMode" required>
                      </CodeTypeValue>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Status</label>
                    </div>


                    <div class="col-md-6">
                      <CodeTypeValue CodeType="FWUS"
                                     id="CurrentEditCounsellingActivityRequest.Followupstatus"
                                     [(ngModel)]="CurrentEditCounsellingActivityRequest.Followupstatus" SelectedValue="CurrentEditCounsellingActivityRequest.Followupstatus"
                                     name="CurrentEditCounsellingActivityRequest.Followupstatus" required>
                      </CodeTypeValue>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                    </div>

                    <div class="col-md-6">
                      <textarea class="form-control3 size-2 width-remarks-206px" rows="3" placeholder="Comments" minlength="1" maxlength="150"
                                name="CurrentEditCounsellingActivityRequest.Remarks"
                                [(ngModel)]="CurrentEditCounsellingActivityRequest.Remarks" required
                                #addconcerns_text="ngModel">
                      </textarea>
                    </div>
                  </div>


                </div>
              </div>



              <!--<div class="row margin-top-10">
    <div class="col-md-12 text-align-center">
      <button (click)="onSubmit()" type="submit" *ngIf='!isRequesting && isvisible' class="btn font-size-13px actions-btn-prime">Save</button>
    </div>
  </div>-->
            </div>
            <div class="col-md-6" *ngIf="IsNewActivity">
              <div class="row border-bot-2px">
                <div class="col-md-12 text-align-left background-yellow">
                  Next Activity
                </div>

              </div>
              <div class="row margin-left-auto margin-bottom-10px margin-top-10">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Schedule Date</label>
                    </div>


                    <div class="col-md-6">
                      <div class="date-form">
                        <input class="form-control" placeholder="Start Date"
                               name="dp2" [(ngModel)]="ScheduleDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth2="ngModel" required>
                        <small class="form-text text-danger"
                               *ngIf="(!DateOfBirth2.valid && (DateOfBirth2.dirty || DateOfBirth2.touched) && DateOfBirth2.errors.required)">(Field cannot be left blank)</small>

                        <a (click)="d2.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>


                        </a>

                      </div>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Schedule Time</label>
                    </div>
                    <div class="col-md-6">
                      <input type="time" class="form-control" id="CurrentSaveCounsellingActivityRequest.ActivityTime" placeholder="Schedule Time"
                             [(ngModel)]="CurrentSaveCounsellingActivityRequest.ActivityTime"
                             name="CurrentSaveCounsellingActivityRequest.ActivityTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime2="ngModel" />

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right margin-tg-auto ">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Follow-up Mode</label>
                    </div>


                    <div class="col-md-6">
                      <CodeTypeValue CodeType="FWUM"
                                     id="CurrentSaveCounsellingActivityRequest.FollowupMode"
                                     [(ngModel)]="CurrentSaveCounsellingActivityRequest.FollowupMode" SelectedValue=""
                                     name="CurrentSaveCounsellingActivityRequest.FollowupMode" required>
                      </CodeTypeValue>

                    </div>
                  </div>


                </div>
              </div>
              <div class="row margin-left-auto margin-bottom-10px">
                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-4 text-align-right">
                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Comments</label>
                    </div>

                    <div class="col-md-6">
                      <textarea class="form-control3 size-2 width-inherit" rows="3" placeholder="Concerns"
                                name="CurrentSaveCounsellingActivityRequest.Remarks"
                                [(ngModel)]="CurrentSaveCounsellingActivityRequest.Remarks" required minlength="1" maxlength="150"
                                #addconcerns_text2="ngModel"></textarea>
                      <small class="form-text text-danger"
                             *ngIf="(!addconcerns_text2.valid && (addconcerns_text2.dirty || addconcerns_text2.touched))">(Required)</small>
                    </div>
                  </div>


                </div>
              </div>
              <!--<div class="row margin-top-10">
        <div class="col-md-12 text-align-center">
          <button (click)="onSubmit2()" class="btn font-size-13px actions-btn-prime">Save</button>
        </div>
      </div>-->
            </div>
          </div>

          <div class="row margin-top-10">
            <div class="col-md-6 text-align-center">
              <button (click)="onSubmit()" type="submit" *ngIf='!isRequesting && isvisible' class="btn font-size-16px data-color-white actions-btn-prime-activity">Save</button>
            </div>
            <div class="col-md-6 text-align-center" *ngIf="IsNewActivity">
              <button (click)="onSubmit2()" class="btn font-size-16px data-color-white actions-btn-prime-activity">Save</button>
            </div>
          </div>
          <div class="row margin-top-10 bk-color-lightgray padding-top-5px padding-bottom-5px">
            <div class="col-md-5">
              <div class="row">
                <div class="col-md-5 padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Created By</label>
                </div>:
                <div class="col-md-6 text-align-left padding-right-5px padding-left-5px">
                  <label class="font-size-13px margin-bottom-0px">
                    {{CreatedUserName}}
                  </label>
                </div>
              </div>

            </div>
            <div class="col-md-6 text-align-right" *canUserAccess="['HL_FU_4']">
              <div class="row">
                <div class="col-md-3 padding-left-0px padding-right-0px">
                  <label class="font-size-13px margin-bottom-0px">Assigned To</label>
                </div>:
                <div class="col-md-6 text-align-left padding-right-5px padding-left-5px">
                  <CustomDataByRequestType RequestedType="EmployeeActorCodeByFacility"
                                           FacilityCode={{FacilityCode}}
                                           (keyChange)="Roleassign($event)"
                                           [(ngModel)]="AssignedToCode" name="AssignedToName"
                                           SelectedValue="AssignedToName"
                                           FontSize="12" Height="1.5">                                           
                  </CustomDataByRequestType>
                </div>
                <div class="col-md-2 padding-left-0px padding-right-0px text-align-left">
                  <a class="font-size-13px underline color-blue nav-link-hand"
                     (click)="ChangeAssignment()">Change</a>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!--<div class="modal-footer padding-top-10px padding-bottom-10px">
          
          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
          <button type="submit" *ngIf='!isRequesting && isvisible' class="btn font-size-13px actions-btn-prime">Save</button>

        </div>-->
        </form>
    </div>
  </div>
